<!--
  Przelacznik jezyka (T8). To sa ZWYKLE linki, nie routerLinki i nie same (click):
  drugi jezyk jest osobnym ADRESEM, a router nie potrafi go wyrazic — serialize()
  dokleja prefiks zamrozony w konstruktorze serializera, wiec nawigacja SPA
  zostalaby w tym samym drzewie jezykowym. <a href> daje pelne przeladowanie
  dokumentu (nowy SSR w docelowym jezyku), a przy okazji jest crawlowalne
  i dziala srodkowym przyciskiem / Ctrl+klik.

  🔴 Adres liczy sie PRZY KAZDEJ NAWIGACJI (langHref$ | async), a nie raz przy
  tworzeniu komponentu. app-root zyje tyle co dokument, wiec wersja jednorazowa
  zamrazala przelacznik na stronie WEJSCIA i po pierwszym kliknieciu w menu
  prowadzil on w zle miejsce.
-->
@if (!(isAdminRoute$ | async) && (currentLang$ | async); as lang) {
  @if (langHref$ | async; as langHref) {
    <div class="lang-switcher-fixed">
      <a class="lang-btn" [class.active]="lang === 'pl'" [href]="langHref.pl"
         hreflang="pl" (click)="rememberLanguage('pl')">
        <span class="fi fi-pl"></span> PL
      </a>
      <span class="lang-divider">|</span>
      <a class="lang-btn" [class.active]="lang === 'en'" [href]="langHref.en"
         hreflang="en" (click)="rememberLanguage('en')">
        <span class="fi fi-gb"></span> EN
      </a>
    </div>
  }
}
<router-outlet></router-outlet>
